import { useEffect, useState } from 'react'
import { useSession } from 'next-auth/react'

import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faPlusSquare, faUpload, faXmark } from '@fortawesome/free-solid-svg-icons';

import { PuffLoader, PulseLoader } from 'react-spinners';

import Resizer from 'react-image-file-resizer'

import errorMsg from '../../../../Functions/errorMsg';
import Image from 'next/image';

import NumberFormat from 'react-number-format';

import ToggleSwitch from '../../../../FunctionalComponents/ToggleSwitch';

import clarifaiApp from '../../../../../mongodb/clarifaiClient'

export default function JobPost({ setMapType, showPolicyPage, pendingRequest, handleCreateListing }) {

    const { data: session, status } = useSession();

    // Business Details (name, logo, address)
    const [businessTitle, setBusinessTitle] = useState("");
    const [businessLogo, setBusinessLogo] = useState(null);
    const [remotePosition, setRemotePosition] = useState(false);
    const [propertyAddress, setPropertyAddress] = useState("");
    const [propertyCity, setPropertyCity] = useState("");
    const [zip, setZIP] = useState('');

    // Position Details
    const [positionTitle, setPositionTitle] = useState(""); // Custom Input (Make sure all words are auto caps when submitting on back-end)
    const [positionType, setPositionType] = useState('Position Type');
    const [employmentTypes, setEmploymentTypes] = useState([]); // part-time, full-time, temporary, contract, apprenticeship, internship & seasonal
    const [shiftTypes, setShiftTypes] = useState([]);  // Day Shift, Afternoon Shift, Evening Shift, Night Shift, Swing Shift, Graveyard Shift, Split Shift, Rotating Shift, On-Call Shift & Flexible Shift
    const [paymentFrequencies, setPaymentFrequencies] = useState([]); // Daily, Weekly, Biweekly, Semimonthly, Monthly, Bi-Monthly & Quarterly
    const [multipleApplicants, setMultipleApplicants] = useState(false); // Yes or No
    const [urgentlyHiring, setUrgentlyHiring] = useState(false); // Yes or No
    const [payoutTypes, setPayoutTypes] = useState([]);
    const [rate, setRate] = useState(null);
    // Payout Types = Cash, Check & Direct Deposit
    // Hourly or Salary

    const [applyPreferences, setApplyPreferences] = useState([]); // walk-in, waco exchange, company website
    const [website, setWebsite] = useState('');
    const [scheduleDetails, setScheduleDetails] = useState(""); // Custom Input
    const [phoneNumber, setPhoneNumber] = useState("");

    // Additional Details
    const [desc, setDesc] = useState("");

    useEffect(() => {
        if(remotePosition) {
            if(zip.length === 5 || zip.length === 10) {
                setMapType({ type: "ZIP", zip: zip });
            } else {
                setMapType(null);
            }
        } else {
            if((zip.length === 5 || zip.length === 10) && propertyAddress.length >= 8 && propertyCity.length >= 3) {
                setMapType({ type: "Location", address: propertyAddress, city: propertyCity, zip: zip });
            } else {
                setMapType(null);
            }
        }

    }, [zip, propertyAddress, propertyCity, remotePosition])

    const handleZIPChange = (e) => {
        let inputValue = e.target.value;

        inputValue = inputValue.replace(/\D/g, '');

        if (inputValue.length > 5) {
          inputValue = inputValue.slice(0, 5) + '-' + inputValue.slice(5);
        }

        inputValue = inputValue.slice(0, 10);

        setZIP(inputValue);
    };

    const handlePhoneChange = (event) => {
        const input = event.target.value.replace(/\D/g, '');
        let formattedPhoneNumber = '';
        
        if (input.length >= 4 && input.length <= 7) {
          formattedPhoneNumber = `(${input.slice(0, 3)}) ${input.slice(3)}`;
        } else if (input.length > 7) {
          formattedPhoneNumber = `(${input.slice(0, 3)}) ${input.slice(3, 6)}-${input.slice(6, 10)}`;
        } else {
          formattedPhoneNumber = input;
        }
        
        setPhoneNumber(formattedPhoneNumber);
      };

      const [posTypeMenu, showPosTypeMenu] = useState(false);

      const changePositionType = (e, type) => {
          e.preventDefault();
          if(type === positionType) return;
          setPositionType(type);
          showPosTypeMenu(false);
      }

    function handleSubmit() {

        const listingData = {
            owner: session.user.token.username,

            businessTitle,
            businessLogo,
            remotePosition,
            propertyAddress,
            propertyCity,
            zip,

            positionTitle,
            positionType,
            employmentTypes,
            shiftTypes,
            paymentFrequencies,
            multipleApplicants,
            urgentlyHiring,
            payoutTypes,
            rate,

            applyPreferences,
            website,
            phoneNumber,
            scheduleDetails,

            desc,

            creationDate: new Date().toISOString()
        }

        handleCreateListing(listingData);
    }

    const [uploadingLogo, setUploadingLogo] = useState(false);

    const uploadLogoMethod = async (e) => {
        e.preventDefault();
    
        if (uploadingLogo) return;
        if (businessLogo) return;
        if (typeof window === 'undefined') return;
    
        const heic2any = require('heic2any');
        const file = e.target.files[0] || e.dataTransfer.files[0];
    
        if (!file) return errorMsg("There was an error uploading your file, please try again later."); 
    
        setUploadingLogo(true);
    
        try {
            let fileSize = (file.size / (1024 * 1024)).toFixed(2);
            if (fileSize > 8) {
                errorMsg("Image is too large, images can be no bigger than 8mb");
                setUploadingLogo(false);
                return;
            }
    
            let resizedImage;

            if (file.name.includes('.HEIC')) {
                const jpegBlob = await heic2any({ blob: file, toType: 'image/jpeg' });
                resizedImage = await resizeFile(jpegBlob);
            } else {
                resizedImage = await resizeFile(file);
            }
    
            const objectUrl = URL.createObjectURL(resizedImage);
    
            // ====
    // Create a FileReader instance
    const reader = new FileReader();

    // Read the Blob as a data URL
    reader.readAsDataURL(resizedImage);

    // Define a callback function for when the reading is complete
    reader.onloadend = async () => {
        // Ensure the result is a string
        if (typeof reader.result !== 'string') {
        console.error('Invalid data URL:', reader.result);
        // Handle the error appropriately, e.g., return or throw an error
        return;
        }

        // Extract the base64 data from the data URL
        const base64Data = reader.result.split(',')[1];

        // Analyze image with Clarifai
        const clarifaiResponse = await clarifaiApp.models.predict(
            Clarifai.GENERAL_MODEL,
            { base64: base64Data }
        );

        const getConcepts = clarifaiResponse?.outputs[0]?.data?.concepts || [];

        const thresholds = {
            nude: 0.7,
            gun: 0.7,
            bomb: 0.7,
            gore: 0.7,
            danger: 0.88,
        };

        const filteredConcepts = getConcepts.filter(concept => {
            return (
            (concept.name === 'nude' && concept.value >= thresholds.nude) ||
            (concept.name === 'gun' && concept.value >= thresholds.gun) ||
            (concept.name === 'bomb' && concept.value >= thresholds.bomb) ||
            (concept.name === 'gore' && concept.value >= thresholds.gore) ||
            (concept.name === 'danger' && concept.value >= thresholds.danger)
            );
        });

        const finalFilter = filteredConcepts.map((conceptData) => {
            return conceptData.name
        })

        console.error(finalFilter);

        if (filteredConcepts.length > 0) {
            errorMsg("The images you're attempting to upload are against our policies.");
        } else {
            const newUpload = {
                url: objectUrl,
                imageFile: file,
            };

            setBusinessLogo(newUpload);
        }
    }

    return () => URL.revokeObjectURL(objectUrl);

    } catch (error) {
        console.error("Error uploading image: ", error);
    } finally {
        setUploadingLogo(false);
    }

        

    };
      
    const resizeFile = (file) =>
        new Promise((resolve, reject) => {
            Resizer.imageFileResizer(
            file,
            750,
            750,
            "PNG",
            100,
            0,
            (uri) => {
                resolve(uri);
            },
            "blob",
            300,
            0
        );
    });

    function removeLogo() {
        if(!businessLogo) return;
        setBusinessLogo(null);
    }

    // ===== End Logo Upload Methods ======

    function handleEmploymentType(type) {
        if(!type) return;

        if (employmentTypes.includes(type)) {
            setEmploymentTypes(employmentTypes.filter((employmentType) => employmentType !== type));
        } else {
            setEmploymentTypes([...employmentTypes, type]);
        }
    }

    function returnSelectedEmploymentTypeButtonStyle(type) {
        if(employmentTypes.includes(type)) {
            return {
                backgroundColor: '#424242',
                fontWeight: '700',
                borderColor: '#424242',
                color: 'white'
            }
        } else {
            return {
                backgroundColor: '#c0c0c0'
            }
        }
    }



    function handleShiftType(type) {
        if(!type) return;

        if (shiftTypes.includes(type)) {
            setShiftTypes(shiftTypes.filter((shiftType) => shiftType !== type));
        } else {
            setShiftTypes([...shiftTypes, type]);
        }
    }

    function returnSelectedShiftTypeButtonStyle(type) {
        if(shiftTypes.includes(type)) {
            return {
                backgroundColor: '#424242',
                fontWeight: '700',
                borderColor: '#424242',
                color: 'white'
            }
        } else {
            return {
                backgroundColor: '#c0c0c0'
            }
        }
    }



    function handlePaymentFrequency(frequency) {
        if(!frequency) return;

        if (paymentFrequencies.includes(frequency)) {
            setPaymentFrequencies(paymentFrequencies.filter((frequencyType) => frequencyType !== frequency));
        } else {
            setPaymentFrequencies([...paymentFrequencies, frequency]);
        }
    }

    function returnSelectedPaymentFrequencyButtonStyle(frequency) {
        if(paymentFrequencies.includes(frequency)) {
            return {
                backgroundColor: '#424242',
                fontWeight: '700',
                borderColor: '#424242',
                color: 'white'
            }
        } else {
            return {
                backgroundColor: '#c0c0c0'
            }
        }
    }



    function handlePayoutOption(option) {
        if(!option) return;

        if (payoutTypes.includes(option)) {
            setPayoutTypes(payoutTypes.filter((optionType) => optionType !== option));
        } else {
            setPayoutTypes([...payoutTypes, option]);
        }
    }

    function returnSelectedPayoutOptionButtonStyle(option) {
        if(payoutTypes.includes(option)) {
            return {
                backgroundColor: '#424242',
                fontWeight: '700',
                borderColor: '#424242',
                color: 'white'
            }
        } else {
            return {
                backgroundColor: '#c0c0c0'
            }
        }
    }



    function handleApplicationPreference(preference) {
        if(!preference) return;

        if (applyPreferences.includes(preference)) {
            setApplyPreferences(applyPreferences.filter((preferenceType) => preferenceType !== preference));
        } else {
            setApplyPreferences([...applyPreferences, preference]);
        }
    }

    function returnSelectedApplicationPreferenceButtonStyle(preference) {
        if(applyPreferences.includes(preference)) {
            return {
                backgroundColor: '#424242',
                fontWeight: '700',
                borderColor: '#424242',
                color: 'white'
            }
        } else {
            return {
                backgroundColor: '#c0c0c0'
            }
        }
    }




    function handleRateSelection(rateType) {
        if(rate && rate.type === rateType) return;

        if(rateType === 'Hourly') {
            setRate({
                type: 'Hourly',
                rate: '',
            })
        }

        if(rateType === 'Salary') {
            setRate({
                type: 'Salary',
                rate: ''
            })
        }

    }

    function returnSelectedRateSelectionButtonStyle(rateType) {
        if(!rateType) return;
        if(rate) {
            if(rate.type === rateType) {
                return {
                    backgroundColor: '#424242',
                    fontWeight: '700',
                    borderColor: '#424242',
                    color: 'white'
                }
            } else {
                return {
                    backgroundColor: '#c0c0c0'
                }
            }
        }
    }

    function handleRateChange(value) {
        if(!rate) return;
        setRate({ ...rate, rate: value });
    }

    const priceValueCap = (inputObj) => {
        const { value } = inputObj;
        if (value <= 10000000) return true;
        return false;
    };


    // Handle able to submit checks

    const [canSubmit, setCanSubmit] = useState(false);

    useEffect(() => {

        var canSubmit = true;

        if(businessTitle.length < 5 || businessTitle.length > 50) canSubmit = false;
        if(businessLogo === null) canSubmit = false;
        if(!remotePosition) {
            if(propertyAddress.length < 8 || propertyCity.length < 2 || zip.length < 5) canSubmit = false;
        } else {
            if(zip.length < 5) canSubmit = false;
        }
        
        if(positionTitle.length < 5 || positionTitle.length > 50) canSubmit = false;
        if(positionType === 'Position Type') canSubmit = false;
        
        if(employmentTypes.length === 0) canSubmit = false;
        if(shiftTypes.length === 0) canSubmit = false;
        if(paymentFrequencies.length === 0) canSubmit = false;
        if(payoutTypes.length === 0) canSubmit = false;
        if(rate === null) canSubmit = false;
        if(rate) {
            if(rate.rate.length === 0) canSubmit = false;
        }

        if(applyPreferences.length === 0) canSubmit = false;
        if(applyPreferences.includes('Company Website') && website.length === 0) canSubmit = false;
        if(scheduleDetails.length < 15 || scheduleDetails.length > 2000) canSubmit = false;
        if(phoneNumber.length !== 14) canSubmit = false;

        setCanSubmit(canSubmit);

    }, [businessTitle, businessLogo, remotePosition, propertyAddress, propertyCity, zip, positionTitle, positionType, employmentTypes, shiftTypes, paymentFrequencies, payoutTypes, rate, applyPreferences, website, scheduleDetails, phoneNumber])

    return (
        <section id={styles.createjob}>

            <section id={styles.wrapper}>

                <div id={styles.enterInfo}>
                    <h1>Employer Logo & Details</h1>

                    <div id={styles.uploadBlock} style={{borderWidth: businessLogo ? '0px' : '2px'}}>
                        { uploadingLogo ? <PuffLoader size={48} color='#818181' /> : <FontAwesomeIcon icon={faUpload} id={styles.icon} /> }
                        { businessLogo && !uploadingLogo && <Image sizes='auto auto' fill objectFit='cover' src={businessLogo.url} alt={businessLogo.url} /> }
                        { businessLogo && !uploadingLogo && <FontAwesomeIcon onClick={removeLogo} icon={faXmark} id={styles.remove} /> }
                        { !businessLogo && !uploadingLogo && <input disabled={pendingRequest} type='file' accept='image/*' onChange={uploadLogoMethod} /> }
                    </div>

                    <section id={styles.title}>
                        <input disabled={pendingRequest} onChange={(e) => setBusinessTitle(e.target.value)} type='text' placeholder="Employer Name" maxLength={50} />
                        { businessTitle !== null && ( businessTitle.length < 5 && <h6>{businessTitle.length - 5}</h6> ) }
                    </section>

                    <section id={styles.toggleSection}>
                        <h2>Remote Position?</h2>
                        <ToggleSwitch isDisabled={pendingRequest} state={remotePosition} setState={setRemotePosition} />
                    </section>
                    { remotePosition && <input disabled={pendingRequest} onChange={handleZIPChange} type='text' placeholder="ZIP Code" maxLength={10} value={zip} /> }

                    <section style={{display: remotePosition ? 'none' : 'flex'}} id={styles.addLocation}>
                        <input disabled={pendingRequest} onChange={(e) => setPropertyAddress(e.target.value)} type='text' placeholder="Address" value={propertyAddress} />
                        <div>
                            <input disabled={pendingRequest} onChange={(e) => setPropertyCity(e.target.value)} type='text' placeholder="City" value={propertyCity} />
                            <input disabled={pendingRequest} onChange={handleZIPChange} type='text' placeholder="ZIP Code" maxLength={10} value={zip} />
                        </div>
                    </section>

                    <h1>Position Details</h1>
                    <section id={styles.title}>
                        <input disabled={pendingRequest} onChange={(e) => setPositionTitle(e.target.value)} type='text' placeholder="Position Title" maxLength={50} />
                        { positionTitle !== null && ( positionTitle.length < 5 && <h6>{positionTitle.length - 5}</h6> ) }
                    </section>

                    <div onMouseLeave={() => showPosTypeMenu(false)} className={styles.dropdown}>
                        <button disabled={pendingRequest} style={{color: positionType === 'Position Type' ? '#818181' : 'black'}} onClick={ (e) => {e.preventDefault(); showPosTypeMenu(posTypeMenu ? false : true)} } className={styles.dropdownBtn}>{positionType} <FontAwesomeIcon icon={faChevronDown} id={styles.icon} /></button>
                        <div style={{height: '200px', display: posTypeMenu === false ? 'none' : 'block'}} className={styles.dropdownContent}>
                            <button onClick={(e) => changePositionType(e, 'Administrative')}>Administrative</button>
                            <button onClick={(e) => changePositionType(e, 'Arts & Design')}>Arts & Design</button>
                            <button onClick={(e) => changePositionType(e, 'Construction & Trades')}>Construction & Trades</button>
                            <button onClick={(e) => changePositionType(e, 'Customer Service')}>Customer Service</button>
                            <button onClick={(e) => changePositionType(e, 'Education & Training')}>Education & Training</button>
                            <button onClick={(e) => changePositionType(e, 'Engineering')}>Engineering</button>
                            <button onClick={(e) => changePositionType(e, 'Finance & Accounting')}>Finance & Accounting</button>
                            <button onClick={(e) => changePositionType(e, 'Food Industry')}>Food Industry</button>
                            <button onClick={(e) => changePositionType(e, 'Healthcare & Biotechnology')}>Healthcare & Biotechnology</button>
                            <button onClick={(e) => changePositionType(e, 'Hospitality & Tourism')}>Hospitality & Tourism</button>
                            <button onClick={(e) => changePositionType(e, 'Human Resources')}>Human Resources</button>
                            <button onClick={(e) => changePositionType(e, 'Legal & Compliance')}>Legal & Compliance</button>
                            <button onClick={(e) => changePositionType(e, 'Logistics & Supply')}>Logistics & Supply</button>
                            <button onClick={(e) => changePositionType(e, 'Manufacturing & Production')}>Manufacturing & Production</button>
                            <button onClick={(e) => changePositionType(e, 'Marketing & Sales')}>Marketing & Sales</button>
                            <button onClick={(e) => changePositionType(e, 'Media & Communications')}>Media & Communications</button>
                            <button onClick={(e) => changePositionType(e, 'Real Estate')}>Real Estate</button>
                            <button onClick={(e) => changePositionType(e, 'Retail')}>Retail</button>
                            <button onClick={(e) => changePositionType(e, 'Science & Research')}>Science & Research</button>
                            <button onClick={(e) => changePositionType(e, 'Social Services')}>Social Services</button>
                            <button onClick={(e) => changePositionType(e, 'Technology & IT')}>Technology & IT</button>
                            <button onClick={(e) => changePositionType(e, 'Other')}>Other</button>
                        </div>
                    </div>

                    <div id={styles.buttonSelectionContainer}>
                        <h2>Employment Types</h2>
                        <section>
                            <button style={returnSelectedEmploymentTypeButtonStyle('Full-Time')} onClick={() => handleEmploymentType('Full-Time')}>Full-Time</button>
                            <button style={returnSelectedEmploymentTypeButtonStyle('Part-Time')} onClick={() => handleEmploymentType('Part-Time')}>Part-Time</button>
                            <button style={returnSelectedEmploymentTypeButtonStyle('Temporary')} onClick={() => handleEmploymentType('Temporary')}>Temporary</button>
                            <button style={returnSelectedEmploymentTypeButtonStyle('Contract')} onClick={() => handleEmploymentType('Contract')}>Contract</button>
                            <button style={returnSelectedEmploymentTypeButtonStyle('Apprenticeship')} onClick={() => handleEmploymentType('Apprenticeship')}>Apprenticeship</button>
                            <button style={returnSelectedEmploymentTypeButtonStyle('Internship')} onClick={() => handleEmploymentType('Internship')}>Internship</button>
                            <button style={returnSelectedEmploymentTypeButtonStyle('Seasonal')} onClick={() => handleEmploymentType('Seasonal')}>Seasonal</button>
                        </section>
                    </div>

                    <div id={styles.buttonSelectionContainer}>
                        <h2>Shift Types</h2>
                        <section>
                            <button style={returnSelectedShiftTypeButtonStyle('Day Shift')} onClick={() => handleShiftType('Day Shift')}>Day Shift</button>
                            <button style={returnSelectedShiftTypeButtonStyle('Afternoon Shift')} onClick={() => handleShiftType('Afternoon Shift')}>Afternoon Shift</button>
                            <button style={returnSelectedShiftTypeButtonStyle('Evening Shift')} onClick={() => handleShiftType('Evening Shift')}>Evening Shift</button>
                            <button style={returnSelectedShiftTypeButtonStyle('Swing Shift')} onClick={() => handleShiftType('Swing Shift')}>Swing Shift</button>
                            <button style={returnSelectedShiftTypeButtonStyle('Graveyard Shift')} onClick={() => handleShiftType('Graveyard Shift')}>Graveyard Shift</button>
                            <button style={returnSelectedShiftTypeButtonStyle('Split Shift')} onClick={() => handleShiftType('Split Shift')}>Split Shift</button>
                            <button style={returnSelectedShiftTypeButtonStyle('Rotating Shift')} onClick={() => handleShiftType('Rotating Shift')}>Rotating Shift</button>
                            <button style={returnSelectedShiftTypeButtonStyle('On-Call Shift')} onClick={() => handleShiftType('On-Call Shift')}>On-Call Shift</button>
                            <button style={returnSelectedShiftTypeButtonStyle('Flexible Shift')} onClick={() => handleShiftType('Flexible Shift')}>Flexible Shift</button>
                        </section>
                    </div>

                    <div id={styles.buttonSelectionContainer}>
                        <h2>Payment Frequency</h2>
                        <section>
                            <button style={returnSelectedPaymentFrequencyButtonStyle('Daily')} onClick={() => handlePaymentFrequency('Daily')}>Daily</button>
                            <button style={returnSelectedPaymentFrequencyButtonStyle('Weekly')} onClick={() => handlePaymentFrequency('Weekly')}>Weekly</button>
                            <button style={returnSelectedPaymentFrequencyButtonStyle('Biweekly')} onClick={() => handlePaymentFrequency('Biweekly')}>Biweekly</button>
                            <button style={returnSelectedPaymentFrequencyButtonStyle('Semimonthly')} onClick={() => handlePaymentFrequency('Semimonthly')}>Semimonthly</button>
                            <button style={returnSelectedPaymentFrequencyButtonStyle('Monthly')} onClick={() => handlePaymentFrequency('Monthly')}>Monthly</button>
                            <button style={returnSelectedPaymentFrequencyButtonStyle('Bimonthly')} onClick={() => handlePaymentFrequency('Bimonthly')}>Bimonthly</button>
                            <button style={returnSelectedPaymentFrequencyButtonStyle('Quarterly')} onClick={() => handlePaymentFrequency('Quarterly')}>Quarterly</button>
                        </section>
                    </div>

                    <section id={styles.buttonSelectionContainer}>
                        <h2>Payout Options</h2>
                        <section>
                            <button style={returnSelectedPayoutOptionButtonStyle('Cash')} onClick={() => handlePayoutOption('Cash')}>Cash</button>
                            <button style={returnSelectedPayoutOptionButtonStyle('Check')} onClick={() => handlePayoutOption('Check')}>Check</button>
                            <button style={returnSelectedPayoutOptionButtonStyle('Direct Deposit')} onClick={() => handlePayoutOption('Direct Deposit')}>Direct Deposit</button>
                        </section>
                    </section>

                    <section id={styles.toggleSection}>
                        <h2>Hiring Multiple Applicants?</h2>
                        <ToggleSwitch isDisabled={pendingRequest} state={multipleApplicants} setState={setMultipleApplicants} />
                    </section>

                    <section id={styles.toggleSection}>
                        <h2>Urgently Hiring?</h2>
                        <ToggleSwitch isDisabled={pendingRequest} state={urgentlyHiring} setState={setUrgentlyHiring} />
                    </section>

                    <section id={styles.ratesSection}>
                        <h2>Position Pay Rate</h2>
                        <section>
                            <button style={returnSelectedRateSelectionButtonStyle('Hourly')} onClick={() => handleRateSelection('Hourly')}>Hourly</button>
                            <button style={returnSelectedRateSelectionButtonStyle('Salary')} onClick={() => handleRateSelection('Salary')}>Salary</button>
                        </section>
                        <section>
                            { rate && <div>
                            <NumberFormat 
                                value={rate.rate} 
                                onValueChange={({ value }) => handleRateChange(value)} 
                                isAllowed={priceValueCap} 
                                decimalScale={2}
                                placeholder={`${rate.type} Rate`} 
                                thousandSeparator={true} 
                                prefix={'$'} 
                                suffix={ rate.type === 'Hourly' ? ' / hr' : ' / year' }
                                />
                            </div> }
                        </section>
                    </section>

                    <section id={styles.scheduleDetails}>
                        <textarea disabled={pendingRequest} onChange={(e) => setScheduleDetails(e.target.value)} placeholder="Describe this positions schedule..." maxLength={2000} />
                        {scheduleDetails !== null && ( scheduleDetails.length < 15 && <h6>{scheduleDetails.length - 15}</h6> )}
                    </section>

                    <section id={styles.buttonSelectionContainer}>
                        <h2>Application Preferences</h2>
                        <section>
                            <button style={returnSelectedApplicationPreferenceButtonStyle('Waco Exchange')} onClick={() => handleApplicationPreference('Waco Exchange')}>Waco Exchange</button>
                            <button style={returnSelectedApplicationPreferenceButtonStyle('Walk-Ins')} onClick={() => handleApplicationPreference('Walk-Ins')}>Walk-Ins</button>
                            <button style={returnSelectedApplicationPreferenceButtonStyle('Company Website')} onClick={() => handleApplicationPreference('Company Website')}>Company Website</button>
                        </section>
                        <input style={{display: applyPreferences.includes('Company Website') ? 'flex' : 'none'}} disabled={pendingRequest} onChange={(e) => setWebsite(e.target.value)} type='url' placeholder="Website URL" />
                    </section>

                    <input disabled={pendingRequest} type='text' placeholder="(123)-456-7890" onChange={handlePhoneChange} value={phoneNumber} />

                    <h1>Additional Details</h1>

                    <section id={styles.desc}>
                        <textarea disabled={pendingRequest} onChange={(e) => setDesc(e.target.value)} placeholder="Description" maxLength={2000} />
                    </section>

                    <p>Jobs are public and can be seen by anyone on or off Waco Exchange. Job hiring for illegal behavior or other unethical behaviors aren't allowed on Waco Exchange. See our <b onClick={() => showPolicyPage(true)}>Policy Page</b> for more info.</p>
                    <button disabled={!canSubmit} onClick={handleSubmit} id={styles.createListing}>
                        { pendingRequest === true ? <PulseLoader size={15} color='white' /> : <> Create Listing <FontAwesomeIcon icon={faPlusSquare} id={styles.icon} /> </>}
                    </button>

                </div>
            </section>
        </section>
    )
}